module.exports = __webpack_public_path__ + "static/xanatos-screenshots-4a98395bf8cfb13afaf48cda9d2de519.png";